export default () => {

  const spotGlobals = {}

  const globals = Object.entries(window.$App.globals.spot)
  globals.forEach((global) => (spotGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return spotGlobals;  
}